import Text from "./Text";
import { formatFirstQuoteDate, MissingQuoteInfo } from "../commons/missing-quote";

interface IMissingQuoteNoticeProps {
    info: MissingQuoteInfo;
    onUseFirstDate?: () => void;
}

export default function MissingQuoteNotice({ info, onUseFirstDate }: IMissingQuoteNoticeProps) {
    const firstLabel = formatFirstQuoteDate(info.first_available_date);

    return (
        <div className="mb-3">
            <Text size="sm" color="600">{info.message}</Text>
            {firstLabel && onUseFirstDate ? (
                <Text
                    size="sm"
                    color="primary"
                    fontWeight="semibold"
                    className="mt-2"
                    onClick={onUseFirstDate}
                >
                    Usar {firstLabel}
                </Text>
            ) : null}
        </div>
    );
}
